<template src="shared/modules/seo/seo-text/homepage-seo-text.html" />
<script>
/* istanbul ignore file */

export default {
  name: 'HomepageSeoTextContent',
};
</script>
